import { Dropdown } from 'antd'
import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const FiltersWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;

  button {
    width: 100%;
    height: 41px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
  }
  .blue-btn {
    background-color: #d6e3fd !important;
    color: #0070f3 !important;
  }
  .basic-btn {
    background-color: #0070f3 !important;
    height: 41px;
    justify-content: center !important;
    padding: 0px 1.1em;
  }

  .ant-badge {
    width: 100%;
    /* opacity: 0.7; */
  }

  .btn-clear {
    padding: 0px;
    // height: auto;
    width: auto;
    text-decoration: underline;
  }

  .ant-border-radius {
    border-radius: 9px;
  }

  .ant-select-selector {
    border-radius: 9px !important;
  }
`

// the classes above are very bad, this is a temporary fix due to global css
// overriding most of the stuff here

// eslint-disable-next-line import/prefer-default-export
export const CustomSelectWrapper = styled(Dropdown)`
  .ant-checkbox-wrapper:first-of-type {
    margin-left: 8px;
  }
`
